import { render, staticRenderFns } from "./AppraisalExaminationPlanList.vue?vue&type=template&id=220bc397"
import script from "./AppraisalExaminationPlanList.vue?vue&type=script&lang=js"
export * from "./AppraisalExaminationPlanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports